import { DomSanitizer } from '@angular/platform-browser';
import { NewsDto } from './../../../shared/service-proxies/service-proxies';
import { MediaLibraryServiceProxy, NewsServiceProxy, TokenAuthServiceProxy, CreateOrUpdateNewsDto, MediaLibraryModel } from '@shared/service-proxies/service-proxies';
import { Component, ElementRef, Injector, Input, OnInit, ViewChild, } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AppComponentBase } from '@shared/common/app-component-base';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { BreadcrumbItem } from '@app/shared/common/sub-header/sub-header.component';
import { DateTime } from 'luxon';
import { AppConsts } from '@shared/AppConsts';

@Component({
  selector: 'seek-news-details',
  animations: [appModuleAnimation()],
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.scss']
})
export class NewsDetailsComponent extends AppComponentBase implements OnInit {
    backLink='home';
    news:NewsDto;
    newsId?
    loc;
    newsImageData:MediaLibraryModel ;
    newsVideoData:MediaLibraryModel;
  constructor(injector: Injector,
    private _tokenAuth: TokenAuthServiceProxy,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _newsServiceProxy: NewsServiceProxy,
    private _mediaLibraryProxy: MediaLibraryServiceProxy,
    private _sinit:DomSanitizer) {
        super(injector);
     }

  ngOnInit() {
      this.newsId = this._activatedRoute.snapshot.queryParams['id'];
      this.loc = this._activatedRoute.snapshot.queryParams['loc'];
      if (this.newsId) {
          if (this.loc == 2)
              this.backLink = 'new-list';
          else if (this.loc == 1)
              this.backLink = 'home';
          this._newsServiceProxy.getPublishedNews(this.newsId).subscribe(newsResult => {
              this.news = newsResult.news;
              if (newsResult.news.newsImageId != null) {
                  this._mediaLibraryProxy.getMedia(newsResult.news.newsImageId).subscribe((mediaResult) => {
                      this.newsImageData =  mediaResult;
                  });
              }
              if (newsResult.news.newsVideoId != null) {
                  this._mediaLibraryProxy.getMedia(newsResult.news.newsVideoId).subscribe((mediaResult) => {
                      this.newsVideoData =  mediaResult;
                  });
              }
          });
      }

  }
  Back(){
    this._router.navigate([this.backLink]);
}
}
